import { render, staticRenderFns } from "./news.vue?vue&type=template&id=30b4e734&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"
import style0 from "./news.vue?vue&type=style&index=0&id=30b4e734&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b4e734",
  null
  
)

export default component.exports